const config = {
  global_isTest: false,
  global_isPass: false, //是否加密
  global_aeskey: "pEAxxz5D+4jBLSwHht9w8zuyEPUQfFTENnzwvS3HThk=", // 通信秘钥
  host:"", //基础域名VUE_APP_BASE_API = '10.150.146.34:8888/'
  imgRoot:"https://qimiyun.oss-cn-hangzhou.aliyuncs.com/",//服务器接口路径
  environment: ''
};

if (process.env.NODE_ENV === 'development') { //development   production
  //开发环境
  // config.host = 'http://dny.vaiwan.com/api/'
  // config.imgRoot = 'http://vr11.vaiwan.com/'
} else {
  //正式环境
  config.global_isTest = false
	// config.host = 'http://114.98.236.67:8230/'
}
export default config
